import InternalBar from "../TopLayout/InternalBar/InternalBar";
import React, {useEffect} from "react";
import './PageTopHeader.css';
import { globalText, globalImages, resolveTutorDetailsSharedAsset } from '../TopLayout/tutorDetailsSharedConfig';
function  PageTopHeader({data}){

    useEffect(()=>{
    })
    return(
        <div className="page-top-header">
            <div className="header-flex">
                <div className="header-flex-icon">
                    <img src={data?.logo} alt="user" width={36} height={36}/> {data?.orgName}
                </div>
                <div className="header-flex-badge">
                    <span>{data?.homeMileStone?.revenue?.points}</span> {globalText.points_label || 'Points'}
                    <img src={resolveTutorDetailsSharedAsset(globalImages.points_icon || 'src/assets/images/pts.png')} alt="pointsgroup" width={18} />
                </div>
            </div>
            <div className="header-progress">
                <div className="header-progress-caption">
                    <h2>{data?.homeMileStone?.revenue?.total}</h2>
                    <span>{globalText.goal_prefix || 'Goal:'} {data?.homeMileStone?.revenue?.goal}</span>
                </div>
                <InternalBar height={12} width={data?.homeMileStone?.revenue?.percentage || 0}/>
            </div>
        </div>
    )
}

export default PageTopHeader;
